import React, { useState, useRef, useEffect, ReactChild } from 'react';
import styles from './EuroInput.scss';
import Formatter from './Formatter';
import NumberField from '../MaterialUi/NumberField';

export interface IEuroInputProps {
    pattern: string;
    value: number;
    name: string;
    label: string | ReactChild;
    theme?: 'default' | 'head';
    onChange: (name: string, val: number) => void;
}

const EuroInput: React.FC<React.PropsWithChildren<IEuroInputProps>> = ({ pattern, value, name, label, onChange, theme = 'default' }) => {
    const handleChange = (ev) => {
        const value = Formatter.getFloat(ev.target.value);

        onChange(name, value);
    };

    const handleValueChange = (name: string, value: number) => {
        onChange(name, value);
    };

    return (
        <div className={styles.euroInput + ' ' + styles[theme]}>
            <div className={styles.label}>{label}</div>
            <div>
                {/* <input type="tel" name={name} pattern={pattern} lang="de-DE" value={value} onChange={handleChange}></input> */}
                <NumberField
                    name={name}
                    label=""
                    value={value}
                    // displayType={'input'}
                    thousandSeparator={'.'}
                    decimalSeparator={','}
                    onChange={handleValueChange}
                    suffix={' €'}
                    decimalScale={2}
                />
                {/* <span className={styles.percent}>€</span> */}
            </div>
        </div>
    );
};

export default EuroInput;
